import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";

const RecipeEditorPage = lazy(() => import("@/features/fabricate/editor-page"));

export const Route = createFileRoute("/_app/fabricate/$id")({
  component: () => (
    <Suspense fallback={null}>
      <RecipeEditorPage />
    </Suspense>
  ),
});
